package top.wcpe.allincore.layout.engine

/**
 * 节点定位策略。
 *
 * 对应 Taffy 的 `TaffyPosition`：
 * - [RELATIVE]：默认；元素参与父容器的 flex 流式布局，inset 仅作位移微调。
 * - [ABSOLUTE]：相对最近 positioned 祖先（或父容器原点）定位，
 *   不占父容器布局空间，由 [LayoutStyle.x] / [LayoutStyle.y] 决定坐标。
 */
enum class PositionMode {
    RELATIVE,
    ABSOLUTE
}
